import { doc, getDoc } from "firebase/firestore";
import { firestore } from "./FirebaseConfig";

// The class the *current teacher* has this student in — i.e. the enrolled class
// the teacher owns (class.teacherId === uid). This is what should be attributed
// on sign-outs and checkouts, NOT enrolledClasses[0], which is whatever class
// the student first signed up for and may belong to a different teacher.
//
// Falls back to the student's first enrolled class for shared students who
// aren't on this teacher's roster. Returns { id, ...classData } or null.
export async function findTeacherClass(student, uid) {
  const ids = student?.enrolledClasses || [];

  // Read a class defensively: an enrolled class that lives in a DIFFERENT school
  // (or is otherwise unreadable) makes getDoc throw permission-denied. Skip those
  // instead of letting one stale/cross-school reference break sign-out/lending.
  const readClass = async (id) => {
    try {
      return (await getDoc(doc(firestore, "classes", id))).data() || null;
    } catch {
      return null;
    }
  };

  // Prefer the class THIS teacher owns.
  for (const id of ids) {
    const data = await readClass(id);
    if (data?.teacherId === uid) return { id, ...data };
  }
  // Else the first readable enrolled class.
  for (const id of ids) {
    const data = await readClass(id);
    if (data) return { id, ...data };
  }
  return null;
}
